import React from 'react';
import { ToolTipContainer} from './styles';
export default  ({ locations, tooltipRef }: { locations?: any, tooltipRef?: any }) => {

  return (
    <>
    <ToolTipContainer ref={tooltipRef}>
      {locations.map((location, index) => <React.Fragment key={index}>{location}{index !== locations.length - 1 ? <br></br>:<></>} </React.Fragment>)}
    </ToolTipContainer>
    </>
  )
};
